module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleD-img2.3874da0c.png";